import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { PARAMS_NAME } from '../constants'
import { getOrderInfo } from '../actions/orderActions'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import qs from 'query-string'
import paths from '../routes/paths'

const useOrderWaitPayment = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const [showPaymentPaypal, setShowPaymentPaypal] = useState(false)
    const [orderSuccessData, setOrderSuccessData] = useState(null)

    useEffect(() => {
        const params = qs.parse(history.location.search)
        let orderID

        if ((orderID = params[PARAMS_NAME.ORDER_WAIT_PAYMENT])) {
            dispatch(
                getOrderInfo({
                    params: { orderID },
                    onDone: ({ success, responseData }) => {
                        if (success) {
                            setOrderSuccessData(responseData?.data)
                            setShowPaymentPaypal(true)
                        } else {
                            history.push({
                                pathname: paths.notFound,
                                state: {
                                    message: t('apiMessage.orderInvalid'),
                                },
                            })
                        }
                    },
                })
            )
        }
    }, [])

    return {
        showPaymentPaypal,
        setShowPaymentPaypal,
        orderSuccessData,
        setOrderSuccessData,
    }
}

export default useOrderWaitPayment
